import { Component, OnInit } from '@angular/core';
import { IndisponibilidadeService } from '../indisponibilidade.service';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { Indisponibilidade } from '../indisponibilidade.model';
import { SelectItem } from 'primeng/api';
import { SelectItemService } from '../../services/select-item.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-indisponibilidade-frm',
  templateUrl: './indisponibilidade-frm.component.html',
  styleUrls: ['./indisponibilidade-frm.component.css']
})
export class IndisponibilidadeFrmComponent implements OnInit {

  entidade: Indisponibilidade;
  public indisponibilidadeTipoItens: SelectItem[];
  public simNaoItens: SelectItem[];
  descricaoExcedida = false;

  constructor(
    private service: IndisponibilidadeService,
    private mensagemService: MensagemService,
    private selectItemService: SelectItemService,
    private location: Location,
    private progressoService: ProgressoService
  ) { }

  ngOnInit(): void {
    this.entidade = {
      suspendePrazos: false,
      descricao: ''
    } as Indisponibilidade;
    this.indisponibilidadeTipoItens = this.selectItemService.getTipoIndisponibilidade();
    this.simNaoItens = this.selectItemService.getSimNaoItens();
  }

  salvar(): void {
    const isInsercao = this.entidade.id === undefined;
    if (!this.isNullOrEmpty(this.entidade.descricao) && this.entidade.descricao.length >= 3000) {
      this.descricaoExcedida = true;
      this.mensagemService.addErro('Erro', 'A descrição não pode exceder 3000 caracteres.');
      return;
    }
    else {
      this.descricaoExcedida = false;
    }
    if (this.entidade.dataInicio && this.entidade.dataFim && this.entidade.dataFim < this.entidade.dataInicio) {
      this.mensagemService.addErro('Erro', 'A data de fim não pode ser anterior à data de início.');
      return;
    }
    this.progressoService.modal();
    this.service.salvar(this.entidade)
      .then(indisponibilidade => {
        this.entidade = indisponibilidade;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'A Indisponibilidade foi salva com sucesso');
        if (isInsercao) {
          this.location.go(`/indisponibilidade/edicao/${this.entidade.id}`);
        }
        this.iniciarAlteracao(indisponibilidade);
      })
      .catch(resposta => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar a indisponibilidade', resposta.error);
        this.progressoService.fechar();
      });
  }

  iniciarInsercao(entidade?: Indisponibilidade): void {
    this.entidade = entidade || {} as Indisponibilidade;
  }

  iniciarAlteracao(entidade: Indisponibilidade): void {
    this.entidade = {
      ...entidade,
      dataInicio:  new Date(entidade.dataInicio),
      dataFim:  new Date(entidade.dataFim)
    };
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service.recuperarPorId(id)
      .then(indisponibilidade => {
        this.progressoService.fechar();
        this.iniciarAlteracao(indisponibilidade);
      })
      .catch(resposta => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar a indisponibilidade para edição.', resposta.error);
      });
  }

  private isNullOrEmpty(value: string): boolean {
    return !value || value.trim().length === 0;
  }
}
